export default getText => key =>
  ({
    title: getText('Search based on', 'Layout_Search_Type'),
    firstname: getText('First name', 'Layout_Search_Type'),
    lastname: getText('Last name', 'Layout_Search_Type'),
    date: getText('DOB', 'Layout_Search_Type'),
    // ssn: getText('ID', 'Layout_Search_Type'),
    header: getText('Patients', 'Layout_Search_Type'),
  }[key])
